import {AfterViewInit, Component, ElementRef, OnChanges, OnDestroy, OnInit, SimpleChanges, ViewChild, ViewChildren} from '@angular/core';
import { BaseComponent } from '../../../../../../shared/components/base/base.component';
import { ReplaySubject, Subject, Subscription } from 'rxjs';
import { FormControl, NgForm } from '@angular/forms';
import { MatOption, MatSelect } from '@angular/material';
import { DocumentTypeService } from '../../../../../../core/services/document-type.service';
import { DocumentTemplateService } from '../../../../../../core/services/document-template.service';
import { UserService } from '../../../../../../core/services/user.service';
import { DocumentService } from '../../../../../../core/services/document.service';
import { MatDialog } from '@angular/material/dialog';
import { NotificationService } from '../../../../../../core/services/notification.service';
import { CommonService } from '../../../../../../core/services/common.service';
import { Message } from '../../../../../../core/class/message';
import { SCREEN_SIZE } from 'src/app/core/constants/screen-size';
import { ReportService } from '../../../../../../core/services/report.service';
import { debounceTime, distinctUntilChanged, map, takeUntil } from 'rxjs/operators';
import { EnumContractEnterpriseStatus, EnumContractStatus } from 'src/app/core/constants/contract';
import FileUtils from '../../../../../../core/services/file-utils';
import { Ng4LoadingSpinnerService } from 'ng4-loading-spinner';
import { ToastrService } from 'ngx-toastr';
import { TranslateService } from '@ngx-translate/core';
import * as _ from 'lodash';
import moment from 'moment';
@Component({
  selector: 'app-contract-processing-report',
  templateUrl: './contract-processing-report.component.html',
  styleUrls: ['./contract-processing-report.component.scss']
})
export class ContractProcessingReportComponent extends BaseComponent implements OnInit, AfterViewInit, OnDestroy, OnChanges {
  /**
   * Check status of document for process update
   */
  checkUpdateDocument = false;
  public warningContractQuantity = false;
  public mediaBreakpoint: any;
  public SCREEN_SIZE = SCREEN_SIZE;
  mode = 11;
  subscription: Subscription;
  enterpriseId;
  checkFocus = true;
  createdDateErr = '';
  expiredDateErr = '';
  @ViewChild('myForm', { static: false }) ngForm: NgForm;
  @ViewChild('groupForm', { static: false }) groupForm: NgForm;

  @ViewChild('timePeriod', { static: false }) timePeriod: MatSelect;
  @ViewChildren('focusInput') focusInput;
  @ViewChild('allSelected', { static: false }) allSelected: MatOption;
  @ViewChild('allSelectedStatus', { static: false }) allSelectedStatus: MatOption;
  @ViewChild('allSelectedResource', { static: false }) allSelectedResource: MatOption;
  @ViewChild('allSelectedCustomer', { static: false }) allSelectedCustomer: MatOption;
  @ViewChild('serviceTypeSelect', { static: false }) serviceTypeSelect: MatSelect;
  @ViewChild('statusSelect', { static: false }) statusSelect: MatSelect;
  @ViewChild('resourceSelect', { static: false }) resourceSelect: MatSelect;
  @ViewChild('signCustomerSelect', { static: false }) signCustomerSelect: MatSelect;
  @ViewChild('typeIdSelect', {static: false}) typeIdSelect: MatSelect;
  @ViewChild('templateSelect', {static: false}) templateSelect: MatSelect;
  @ViewChild('allSelectedTemplate', {static: false}) allSelectedTemplate: MatOption;
  selectedOptions: FormControl = new FormControl();

  documents = new Documents();
  exportForm = new Documents()
  EnumContractStatus = EnumContractStatus;
  EnumContractEnterpriseStatus = EnumContractEnterpriseStatus;

  public filteredServiceTypes: ReplaySubject<comboBox[]> = new ReplaySubject<comboBox[]>(1);
  serviceTypes: comboBox[] = [];
  isServiceTypesLoading = false;
  serviceTypesFilterCtrl: FormControl = new FormControl();

  public filteredSignCustomer: ReplaySubject<comboBox[]> = new ReplaySubject<comboBox[]>(1);
  signCustomerFilterCtrl: FormControl = new FormControl();
  signCustomers: comboBox[] = [];
  selectSignCustomerMap = new Map();

  public filteredTemplates: ReplaySubject<comboBox[]> = new ReplaySubject<comboBox[]>(1);
  templateFilterCtrl: FormControl = new FormControl();
  templates: comboBox[] = [];

  sortName = '';
  sortType = '';

  // tslint:disable-next-line:variable-name
  private _onDestroy = new Subject<void>();
  showSpinner = false;

  isNotAttestedUser: boolean = false;
  isExpanded = true;
  signedDateErr: string;
  entType: any = localStorage.getItem('entType');
  maxDate = new Date()

  constructor(
    private documentTypeService: DocumentTypeService,
    private documentTemplateService: DocumentTemplateService,
    private usService: UserService,
    private documentService: DocumentService,
    private dialog: MatDialog,
    private notificationService: NotificationService,
    public commonService: CommonService,
    public message: Message,
    private reportService: ReportService,
    private spinnerService: Ng4LoadingSpinnerService,
    private toastr: ToastrService,
    private translateService: TranslateService
  ) {
    super(commonService, message);
    this.isNotAttestedUser = this.commonService.checkEnterpriseType();
  }

  ngOnInit() {
    this.enterpriseId = localStorage.getItem('enterpriseId');
    this.notificationService.subscribeErrorService();
    window.scrollTo(0, 0);

    // this.commonService.aut
    // this.filteredBranches =

    this.serviceTypesFilterCtrl.valueChanges
      .pipe(takeUntil(this._onDestroy))
      .subscribe(
        value => {
          this.commonService.filterCertificateType(this.serviceTypes, this.serviceTypesFilterCtrl, this.filteredServiceTypes);
        });

    this.signCustomerFilterCtrl.valueChanges.pipe(takeUntil(this._onDestroy))
      .subscribe(
        value => {
          this.commonService.filterCertificateType(this.signCustomers, this.signCustomerFilterCtrl, this.filteredSignCustomer);
        });

    this.templateFilterCtrl.valueChanges.pipe(takeUntil(this._onDestroy))
      .subscribe(
        value => {
          this.commonService.filterCertificateType(this.templates, this.templateFilterCtrl, this.filteredTemplates);
        });

    this.getServiceTypeByEnterprise();
    this.getSignCustomer();
    this.getTemplates();

    // this.branchesFilterCtrl.valueChanges.
  }

  ngOnChanges(changes: SimpleChanges): void {
    console.log('changes', changes);
  }

  ngAfterViewInit(page: number = 0) {
    // setTimeout(_ => this.focusInput.first.nativeElement.focus());
  }

  ngOnDestroy() {
    this.notificationService.unsubscribeErrorService();
  }

  /**
   * Get data when init
   */
  loadData() {
  }

  onExportReport() {
    console.log('send info excel', this.documents);
    this.exportForm = _.cloneDeep(this.documents)
  }

  getServiceTypeByEnterprise() {
    const enterpriseId = localStorage.getItem('enterpriseId');
    this.isServiceTypesLoading = true;
    this.commonService.getEnterpriseServiceType(enterpriseId).subscribe(rs => {
      this.isServiceTypesLoading = false;
      if (rs && rs.data) {
        this.serviceTypes = rs.data;
        this.filteredServiceTypes.next(rs.data.slice());
      }
    }, () => this.isServiceTypesLoading = false);
  }

  getSignCustomer(filter: string = '') {
    this.commonService.getAutoCompleteSignCustomerByUser(filter).subscribe(rs => {
      if (rs && rs.data) {
        const listToAdd = rs.data.slice();
        const selectedList = this.selectSignCustomerMap.values();
        if (this.commonService.isNullOrEmpty(filter)) {
          for (const item of selectedList) {
            const exist = rs.data.findIndex(el => el.id === item.id) > -1;
            if (!exist) {
              listToAdd.unshift(item);
            }
          }
        }
        this.filteredSignCustomer.next(listToAdd);
        this.signCustomers = listToAdd;
      }
    });
  }


  scrollToElement(){
    const textLayer = document.getElementById('inforReport');
    if(textLayer)
      textLayer.scrollIntoView();
  }

  clickPanel(){
    if(!this.isExpanded){
      this.isExpanded = true;
    }
  }
  filterForm(filterForm) {
    this.clickPanel();
    this.scrollToElement();
    this.documents = new Documents;
    if (!filterForm.contractProcessing) {
      window.scrollTo(0, 0);
      return
    }
    let data = filterForm.contractProcessing
    if (data.customerId) {
      data.customerId = data.customerId.map((item) => {
        if (item === '0')
          return +item
        else
          return item
      })
    }
    if (data.receivedAt)
      data.receivedAt = moment(data.receivedAt).format('YYYY-MM-DD')
    this.documents = data
    window.scrollTo(0, 0);
  }

  unSelectSort() {
    this.sortName = null;
    this.sortType = null;
  }
  allowOnlyNumbersAndSpace(event: KeyboardEvent): void {
    const allowedRegex = /^[0-9 ]$/;
    const key = event.key;

    if (!allowedRegex.test(key)) {
      event.preventDefault();
    }
  }

  getTemplates() {
    this.documentService.getDocumentsType().subscribe(rs => {
      if (rs && rs.data) {
        this.templates = rs.data.map((item: any) => ({
          id: item.id,
          name: item.name
        }));
        this.filteredTemplates.next([...this.templates]);
      }
    });
  }

  clickOptionTemplateAll() {
    if (this.allSelectedTemplate.selected) {
      this.templateSelect.options.filter(x => x.value !== undefined && x.value !== -1).forEach((item: MatOption) => {
        item.select();
      });
    } else {
      this.templateSelect.options.filter(x => x.value !== undefined && x.value !== -1).forEach((item: MatOption) => {
        item.deselect();
      });
    }
  }

  clickOptionTemplate() {
    if (this.allSelectedTemplate.selected) {
      this.allSelectedTemplate.deselect();
    }
    if (this.templateSelect.options.length - 2 === this.documents.templateIds.length) {
      this.allSelectedTemplate.select();
    }
  }
}

export class Documents {
  id: string;
  contractCode: string;
  contractName: string;
  userName: string;
  phone: string;
  status: any;
  receivedAt: any;
  email: string;
  serviceType: any;
  templateIds: any = [];
}
